import { render, staticRenderFns } from "./NotificationsCard.vue?vue&type=template&id=71398576&"
import script from "./NotificationsCard.vue?vue&type=script&lang=js&"
export * from "./NotificationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports